export default __webpack_public_path__ + "static/media/presentation.ec975ed6.pptx";